import React from "react";
import PyCell from "../../components/PyCell";

const cell1 = `import numpy as np, pandas as pd
df = pd.DataFrame({"age":[22,35,None,44,52], "city":["Pune","mumbai","Mumbai","Delhi",None]})
print("Raw:"); print(df)
df["age"] = df["age"].fillna(df["age"].median())
df["city"] = df["city"].fillna("Unknown").str.title()
print("\\nClean:"); print(df)`;

const cell2 = `import matplotlib.pyplot as plt
import numpy as np
x = np.linspace(0, 2*np.pi, 200)
plt.plot(x, np.sin(x), label="sin")
plt.legend()
__stt_emit_png()`;

const cell3 = `from sklearn.preprocessing import OneHotEncoder
import numpy as np
X = np.array([["Pune"],["Mumbai"],["Delhi"],["Pune"]])
enc = OneHotEncoder(sparse_output=False).fit(X)
print(enc.get_feature_names_out(["city"]))
print(enc.transform(X))`;

export default function Playground() {
  return (
    <main className="docs-wrap">
      <div className="docs-layout">
        <aside className="docs-toc">
          <strong>On this page</strong>
          <a href="#intro">Intro</a>
          <a href="#clean">Clean</a>
          <a href="#plot">Plot</a>
          <a href="#encode">Encode</a>
        </aside>

        <article>
          <header className="stt-hero">
            <div className="stt-pill">Practice • Python</div>
            <h1 className="stt-h1">In-browser Python Playground</h1>
            <p className="stt-lead">Run NumPy, Pandas, Matplotlib, scikit-learn directly on this page.</p>
          </header>

          <section id="intro" className="stt-section">
            <p className="stt-p">This uses <strong>Pyodide</strong> (Python in WebAssembly). No install, works offline once loaded.</p>
          </section>

          <section id="clean" className="stt-section">
            <h2 className="stt-h2">1) Clean a tiny DataFrame</h2>
            <PyCell code={cell1} />
          </section>

          <section id="plot" className="stt-section">
            <h2 className="stt-h2">2) Plot a quick chart</h2>
            <PyCell code={cell2} />
          </section>

          <section id="encode" className="stt-section">
            <h2 className="stt-h2">3) One-hot encode</h2>
            <PyCell code={cell3} />
          </section>
        </article>
      </div>
    </main>
  );
}
